import { Injectable } from '@angular/core';
import { FormsFlag } from '@benefitsui/app/api/benefits-clients';
import { TableData } from '@dxo/ng-swift-ui';
import { TableCell, TableHeader } from '@dxo/ng-swift-ui/lib/components/table/components/table-base/table.types';
import { FormCellItemType, LeterFormCellItemType } from './forms-page.types';
import { formatActiveEnvironmentDocumentLink } from '@benefitsui/app/shared/activeenvironment/activeenvironment';

@Injectable({
  providedIn: 'root'
})

export class FormsService {
  selectStateBodyHeader = 'Select employee resident state';

  employeeForms: FormCellItemType[] = [];
  claimsForms: FormCellItemType[] = [];
  taxForms: FormCellItemType[] = [];
  customerForms: FormCellItemType[] = [];
  letterForms: LeterFormCellItemType[] = [];

  getLetterFormsData(): LeterFormCellItemType[] | undefined {
    return this.letterForms;
  }

  getFormsData(formFlag: FormsFlag): FormCellItemType[] | undefined {
    if(formFlag === FormsFlag.EmployeeForm){
      return this.employeeForms
    }
    else if(formFlag === FormsFlag.ClaimsForm){
      return this.claimsForms
    }
    else if(formFlag === FormsFlag.TaxForm){
      return this.taxForms
    }
    else if(formFlag === FormsFlag.CustomerForm){
      return this.customerForms
    }
    return undefined;
  }

  setLetterFormsData(data: LeterFormCellItemType[]): void {
      const formData = data.map((letter) => {
        return {
          statementDate: letter.statementDate ??  '',
          planYear: letter.planYear ??  '',
          fileUri: letter.fileUri ??  '',
          fileId: letter.fileId ?? ''
        } as LeterFormCellItemType;  
      });
      this.letterForms = formData;
    }

  setFormsData(data: FormCellItemType[], formFlag: FormsFlag): void {
    const formData = data.map((x) => {
      return {
        id: x.id,
        formsFlag: x.formsFlag,
        name: x.name,
        englishFormNumber: x.englishFormNumber,
        englishUrl: x.englishUrl,
        includedCoverages: x.includedCoverages,
        includedPlanCodes: x.includedPlanCodes,
        includedStates: x.includedStates,
        excludedStates: x.excludedStates,
        portability: x.portability,
        acceleratedDeath: x.acceleratedDeath,
        waiverOfPremium: x.waiverOfPremium,
        conversion: x.conversion
      } as FormCellItemType;  
    });

    if(formFlag === FormsFlag.EmployeeForm){
      this.employeeForms = formData;
    }
    else if(formFlag === FormsFlag.ClaimsForm){
      this.claimsForms = formData;
    }
    else if(formFlag === FormsFlag.TaxForm){
      this.taxForms = formData;
    }
    else if(formFlag === FormsFlag.CustomerForm){
      this.customerForms = formData;
    }
  }

  transformLetterData(data: LeterFormCellItemType[]): TableData {
    const tableData = data.map((req) => {
      const returnForms = {
        formName: req.planYear,
        formNumber: req.fileId ?? '',
        formUrl: this.formatDocumentLink(req.fileUri ?? '')
      };
      return returnForms;
    });
  
    const headers: TableHeader[] = [{ text: 'Date range', width: '100%' }];
    const cells: TableCell[][] = [];
  
    tableData?.forEach((formData) => {
      cells.push([
        {
          link: {
            download: false,
            href: formData.formUrl ?? ''
          },
          display: formData.formName  + ' (PDF)',
          icon: true,
          iconName: 'open_in_new'         
        }
      ]);
    });

    return { headers, cells };
  }
  
  transformData(data: FormCellItemType[]): TableData {
    const tableData = data.map((req) => {
      const returnForms = {
        formName: req.name,
        formNumber: req.englishFormNumber,
        formUrl: req.englishUrl
      };
      return returnForms;
    });
  
    const headers: TableHeader[] = [{ text: 'Form name', width: '60%' }, { text: "Form number"}];
    const cells: TableCell[][] = [];
  
    tableData?.forEach((formData) => {
      cells.push([
        {
          link: {
            download: false,
            href: formData.formUrl
          },
          display: formData.formName,
          icon: true,
          iconName: 'open_in_new'         
        },
        {data: formData.formNumber ?? '' }
      ]);
    });

    return { headers, cells };
  }
  
  formatDocumentLink(item: string): string {
    return formatActiveEnvironmentDocumentLink(item);
  }
}
